var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({class:['blw-control blw-text-field', { embedded: _vm.embedded }],on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-text-field',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }